<template>
      <div class="bottom">
        <div class="row ribbon-dark">
          <div :class="['col text-center pt-3 pb-3 sub-title', { 'visible': visible }]">
            <router-link tag="a" :to="{ name: 'objectbeveiliging' }" class="inline mr-3" title="Objectbeveiliging">OBJECTBEVEILIGING</router-link>
            <span class="invisible-sm">|</span>
            <router-link tag="a" :to="{ name: 'alarm-opvolging' }" class="inline ml-3 mr-3" title="Alarm Opvolging">ALARMOPVOLGING</router-link>
            <span class="invisible-sm">|</span>
            <router-link tag="a" :to="{ name: 'evenementenbeveiliging' }" class="inline ml-3 mr-3" title="Evenementenbeveiliging">EVENEMENTENBEVEILIGING</router-link>
            <span class="invisible-sm">|</span>
            <router-link tag="a" :to="{ name: 'mobiele-surveillance' }" class="mr-3 ml-3 inline" title="Surveillance">SURVEILLANCE</router-link>
            <span class="invisible-sm">|</span>
            <router-link tag="a" :to="{ name: 'monitoring' }" class="inline ml-3" title="Monitoring">MONITORING</router-link>
          </div>
        </div>
        <div class="row text-center images ">
          <div :class="['col-md-4 p-0 service-block', { 'visible': visible }]">
            <router-link tag="a" :to="{ name: 'security' }" >
              <img src="@/assets/security.webp" alt="Beveiliging" />
              <div class="vertical-center">
                <h2>Beveiliging</h2>
              </div>
            </router-link>
          </div>
          <div :class="['col-md-4 p-0 service-block', { 'visible': visible }]">
            <router-link tag="a" to="#" >
              <img src="@/assets/technology.webp" alt="Technologie" />
              <div class="vertical-center">
                <h2>Technologie</h2>
              </div>
            </router-link>
          </div>
          <div :class="['col-md-4 p-0 service-block', { 'visible': visible }]">
            <router-link tag="a" to="#" >
              <img src="@/assets/analytics.webp" alt="Analytics" />
              <div class="vertical-center">
                <h2>Analytics</h2>
              </div>
            </router-link>
          </div>
          <div class="col-md-12 pt-5 pb-5">
            <h5 class="m-0 region">
              <strong>Rijnland Beveiliging</strong> is actief in de regio Rijnland, omvattende o.a. de gemeenten:
              <br />
              <br />
              <span v-for="(c, i) in cities" :key="i"><router-link tag="a" :to="{ name: 'city', params: { city: c }}" :title="'Beveiliging in ' + c">{{c}}</router-link><span v-if="i < cities.length - 1">, </span></span>.
            </h5>
          </div>
        </div>
      </div>
</template>

<script>
export default {
    data() {
      return {
        visible: false,
        cities: ['Leiden', 'Voorschoten', 'Oegstgeest', 'Leiderdorp', 'Zoeterwoude', 'Katwijk', 'Noordwijk', 'Teylingen', 'Lisse', 'Hillegom', 'Kaag en Braassem', 'Alphen aan de Rijn', 'Nieuwkoop']
      }
    },
    created() {
      let self = this;
      window.addEventListener("load", () => {
        self.visible = true;
      });
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles.scss";
.bottom {
  height: 35%;

  h2 {
    text-decoration: none;
    color: #fff;
    text-transform: uppercase;
    font-weight: bolder;
    letter-spacing: 3px;
  }

  .images {
    margin-bottom: 50px;
    background-color: $darkColor;
    img {
      width: 100%;
      opacity: 0.4;
      transition: opacity 1s;
    }
    img:hover {
      opacity: 1;
    }
  }
  .ribbon-white {
    color: $darkColor;
    font-weight: bold;
    background-color: #fff;
    
    word-spacing: 20px;
    letter-spacing: 3px;
  }
  .ribbon-dark {
    color: $darkColor;
    font-weight: bold;
    background-color: $lightColor;
    
    word-spacing: 20px;
    letter-spacing: 2px;
    a {
      color: $darkColor;
    }
  }
}

.sub-title,
.service-block {
  opacity: 0;
  -webkit-transition: opacity .5s; /* Safari prior 6.1 */
  transition: opacity .5s;
}

.sub-title.visible,
.service-block.visible {
  opacity: 1;
}


</style>